export const BOOKINGTYPES_LOADING = 'REDUX_SAGA_BOOKINGTYPES_LOADING';
export const GET_BOOKINGTYPES_DATA_SUCCESS = 'REDUX_SAGA_GET_BOOKINGTYPES_DATA_SUCCESS';
export const GET_BOOKINGTYPES_DATA_ERROR = 'REDUX_SAGA_GET_BOOKINGTYPES_DATA_ERROR';
export const GET_BOOKINGTYPE_DATA = 'REDUX_SAGA_GET_BOOKINGTYPE_DATA';
export const RESET_BOOKINGTYPES_DATA = 'REDUX_SAGA_RESET_BOOKINGTYPES_DATA';
export const REMOVE_UNUSED_BOOKINGTYPES = 'REDUX_SAGA_REMOVE_UNUSED_BOOKINGTYPES';

export const actionGetBookingTypes = (dispatch, id, isDisplay, listOfIds) => {
    dispatch({
        type: BOOKINGTYPES_LOADING, id: id, isDisplay: isDisplay, listOfIds: listOfIds
    })
};

export const actionResetBookingTypes = (dispatch) => {
    dispatch({ type: RESET_BOOKINGTYPES_DATA })
}

export const actionRemoveUnusedBookingTypes = (dispatch) => {
    dispatch({ type: REMOVE_UNUSED_BOOKINGTYPES })
}

